
import React, { useContext } from "react";
import { FaSearch, FaLightbulb, FaTools, FaFileAlt } from 'react-icons/fa';
import { useNavigate } from "react-router-dom";
import { AuthContext } from "../../context/AuthContext";
import './ConsultancyGlobal.css';
import BannerImage from './consultancy_hero.png';

function RCA() {
  const navigate = useNavigate();
  const { isAuthenticated } = useContext(AuthContext);

  const handleBooking = () => {
    if (isAuthenticated) {
      navigate('/booking/rca-consultancy');
    } else {
      navigate('/login', { state: { from: '/booking/rca-consultancy' } });
    }
  };

  return (
    <div className="consultancy-page">
      <div className="consultancy-max-width">

        {/* --- HERO --- */}
        <div className="consultancy-hero" style={{ backgroundImage: `url(${BannerImage})` }}>
          <span className="hero-tag">Incident Analysis</span>
          <h1 className="hero-title">Root Cause Analysis (RCA)</h1>
          <p className="hero-subtitle">
            Solving problems at their source. Prevent recurrence by digging deeper than the symptoms.
          </p>
          <button onClick={handleBooking} className="btn-hero">
            Book Now <span style={{ fontSize: '1.2em' }}>→</span>
          </button>
        </div>

        {/* --- CONTENT --- */}
        <div className="detail-content">

          <div className="content-article">
            <div className="article-section">
              <h2 className="article-heading">Beyond the "Band-Aid" Fix</h2>
              <p className="article-text">
                Too often, organizations fix the immediate symptom without addressing the underlying cause.
                RCA is a structured method used to identify the root causes of faults or problems.
                We use proven methodologies like <strong>The 5 Whys</strong>, <strong>Fishbone Diagrams</strong>,
                and <strong>Fault Tree Analysis</strong>.
              </p>
            </div>

            <div className="article-section">
              <h2 className="article-heading">Accident Investigation</h2>
              <p className="article-text">
                When an incident occurs, speed and precision are key. We help you conduct thorough investigations
                to gather evidence, interview witnesses, and reconstruct events. The goal is not blame, but learning.
              </p>
            </div>

            <div className="article-section">
              <h2 className="article-heading">Corrective Actions (CAPA)</h2>
              <p className="article-text">
                Identifying the cause is half the battle. We help you design specific, measurable, achievable,
                relevant, and time-bound (SMART) corrective actions to ensure the issue never happens again.
              </p>
            </div>
          </div>

          {/* --- SIDEBAR --- */}
          <div className="content-sidebar">
            <div className="sidebar-widget">
              <h4 className="widget-title">RCA Tools</h4>
              <ul className="key-list">
                <li><FaSearch className="check-icon" /> The 5 Whys</li>
                <li><FaFileAlt className="check-icon" /> Fishbone Diagram</li>
                <li><FaTools className="check-icon" /> Fault Tree Analysis</li>
                <li><FaLightbulb className="check-icon" /> Brainstorming</li>
              </ul>
            </div>

            <div className="sidebar-widget" style={{ background: 'linear-gradient(135deg, #111 0%, #222 100%)', border: '1px solid #333' }}>
              <h4 className="widget-title">Stop Recurrence</h4>
              <p style={{ color: '#ccc', marginBottom: '20px', fontSize: '0.9rem' }}>
                Solve problems permanently.
              </p>

              <button
                onClick={handleBooking}
                className="btn-primary"
                style={{ width: '100%', justifyContent: 'center' }}
              >
                Book Now
              </button>
            </div>
          </div>

        </div>
      </div>
    </div>
  );
}

export default RCA;
